import './authStage.css';
import AuthPhones from './AuthPhones';

/**
 * Responsive shell for /login and /signup.
 * Below 760px: light form only.
 * 760–1099px: navy surround and the Home screenshot on the left.
 * 1100px and wider: the My Card screenshot on the right as well.
 * The screenshots are aria-hidden and contain no controls.
 */
export default function AuthStage({ children, testId }) {
  return (
    <div className="pik-auth-stage" data-testid={testId}>
      <aside className="pik-auth-side pik-auth-side-left" aria-hidden="true" inert data-testid="auth-phone-home">
        <AuthPhones side="left" />
      </aside>
      <main className="pik-auth-sheet">
        <div className="pik-auth-sheet-inner">{children}</div>
      </main>
      <aside className="pik-auth-side pik-auth-side-right" aria-hidden="true" inert data-testid="auth-phone-card">
        <AuthPhones side="right" />
      </aside>
    </div>
  );
}
